/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';

import { FlexLayout, FlexItem, Checkbox, Button } from '@waca/ca-ui-toolkit';

import stringResource from 'ba-filter-nls';

export default class FilterPreferences extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		showIncludeNull: PropTypes.bool,
		inverted: PropTypes.bool.isRequired,
		includeNulls: PropTypes.bool.isRequired,
		onChange: PropTypes.func.isRequired,
		onClear: PropTypes.func,
		showReturnToTree: PropTypes.bool,
		returnToTree: PropTypes.func.isRequired,
		showInvertSelected: PropTypes.bool,
		blankValuesLabel: PropTypes.string,
		readOnly: PropTypes.bool,
		invertDisabled: PropTypes.bool,
	};

	static defaultProps = {
		showIncludeNull: true,
		showReturnToTree: false,
		selectedValuesCount: 0,
		showInvertSelected: true,
		blankValuesLabel: stringResource.get('includeBlankValues'),
		readOnly: false,
		invertDisabled: false,
	};

	// Event handlers

	// The includeNulls property has changed
	_onIncludeNullsChanged = value => {
		const result = {
			includeNulls: value,
		};

		this.props.onChange(result);
	};

	// The inverted property has changed
	_onInvertedChanged = () => {
		const result = {
			inverted: !this.props.inverted,
		};

		this.props.onChange(result);
	};

	_onClear = () => {
		if (this.props.onClear !== undefined) {
			this.props.onClear();
		}
	};

	render() {
		const {
			includeNulls,
			showIncludeNull,
			showReturnToTree,
			returnToTree,
			showInvertSelected,
			blankValuesLabel,
			readOnly,
			invertDisabled,
		} = this.props;

		return (
			<FlexItem data-tid="filterPreferenceSection">
				<FlexItem padding={[0, 0, 2, 0]} grow>
					{showIncludeNull ? (
						<Checkbox
							label={blankValuesLabel}
							onChange={this._onIncludeNullsChanged}
							checked={includeNulls}
							readOnly={readOnly}
							data-tid="includeNullsClickable"
						/>
					) : (
						showReturnToTree && (
							<Button
								data-tid="returnToTreeClickable"
								variant="inline"
								intent="primary"
								label={stringResource.get('returnToTree')}
								text={stringResource.get('returnToTree')}
								aria-label={stringResource.get('returnToTree')}
								onClick={returnToTree}
								disabled={readOnly}
							/>
						)
					)}
				</FlexItem>
				<FlexLayout direction="row">
					<FlexItem textAlign="left" grow>
						<Button
							data-tid="clearAllClickable"
							intent="primary"
							variant="inline"
							label={stringResource.get('clearAll')}
							title={stringResource.get('clearAll')}
							aria-label={stringResource.get('clearAll')}
							onClick={this._onClear}
							disabled={readOnly}
						/>
					</FlexItem>
					<FlexItem>
						{showInvertSelected && (
							<Button
								data-tid="invertSelectionClickable"
								variant="inline"
								intent="primary"
								label={stringResource.get('invert')}
								title={stringResource.get('invert')}
								aria-label={stringResource.get('invert')}
								onClick={this._onInvertedChanged}
								disabled={readOnly || invertDisabled}
							/>
						)}
					</FlexItem>
				</FlexLayout>
			</FlexItem>
		);
	}
}
